import { Typography } from '@mui/material'
import useSlider from './hooks/useSlider'
import Slider from '../control/Slider'

type SliderPlaygroundType = ReturnType<typeof useSlider>

const SliderPlaygroundView = (props: SliderPlaygroundType) => {
    const { onChange } = props

    return (
        <div style={{ width: 300, paddingLeft: 30 }}>
            <Typography variant="h3" gutterBottom>
                Control: Slider
            </Typography>
            <Slider label={'Transparency'} displayLabel={'on'} onChange={onChange} />
            <Slider label={'Transparency'} min={10} max={50} defaultValue={35} />
            <Slider label={'Transparency (required)'} stepValue={10} required />
            <Slider label={'Transparency (disabled)'} disabled />
        </div>
    )
}

//Controller
const SliderPlayground = () => {
    const sliderModel = useSlider()
    return <SliderPlaygroundView {...sliderModel} />
}

export default SliderPlayground
